import { render } from "./VatView.vue?vue&type=template&id=498c5a3f"
import script from "./VatView.vue?vue&type=script&lang=js"
export * from "./VatView.vue?vue&type=script&lang=js"

import "./VatView.vue?vue&type=style&index=0&id=498c5a3f&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__